export { default as DateDisplay, DateDisplayVariant } from "./DateDisplay";
